import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ImageSourceSetData } from "../../../../common/classes/ImageSourceSet";
import { PageVisibility } from "../../../../utils/PageVisibility";
import {
  genStatusText,
  getDefaultImage,
  parsePrefecture,
} from "../../../../utils/GeneralUtils";
import styles from "./FacilitySettingItem.module.scss";
import cardStyles from "../../../facility/top/ListCard.module.scss";
import SonicLink from "../../../../common/routing/SonicLink";

type Props = {
  id: string;
  name: string;
  img?: ImageSourceSetData;
  status: string;
  prefecture?: string;
  handleMenu: () => void;
  isMenuOpen: boolean;
  handlePublish: (id: string) => void;
  handlePrivate: (id: string) => void;
  handleDeletionRequest: (id: string) => void;
};

const FacilitySettingItem: React.FC<Props> = ({
  id,
  name,
  img,
  status,
  prefecture,
  handleMenu,
  isMenuOpen,
  handlePublish,
  handlePrivate,
  handleDeletionRequest,
}) => {
  const status_class =
    status === PageVisibility.AwaitingInspection
      ? styles["pending"]
      : status === PageVisibility.PubliclyVisible
      ? styles["open"]
      : status === PageVisibility.DeletionRequest
      ? styles["delete"]
      : "";

  return (
    <div className={styles["f-facilitySettingItem"]}>
      <div
        className={`${styles["f-facilitySettingItem__status"]} ${status_class}`}
      >
        {genStatusText(status)}
      </div>
      <ListCard name={name} img={img} prefecture={prefecture} />
      <button
        className={styles["f-facilitySettingItem__menuBtn"]}
        onClick={handleMenu}
      >
        <FontAwesomeIcon icon={["fal", "ellipsis-h"]} />
      </button>
      <Menu
        id={id}
        name={name}
        status={status}
        handleMenu={handleMenu}
        isMenuOpen={isMenuOpen}
        handlePublish={handlePublish}
        handlePrivate={handlePrivate}
        handleDeletionRequest={handleDeletionRequest}
      />
    </div>
  );
};

export default FacilitySettingItem;

type MenuProps = {
  id: string;
  name: string;
  status: string;
  handleMenu: () => void;
  isMenuOpen: boolean;
  handlePublish: (id: string) => void;
  handlePrivate: (id: string) => void;
  handleDeletionRequest: (id: string) => void;
};

const Menu: React.FC<MenuProps> = ({
  id,
  name,
  status,
  handleMenu,
  isMenuOpen,
  handlePublish,
  handlePrivate,
  handleDeletionRequest,
}) => {
  return (
    <div
      className={
        isMenuOpen
          ? `${styles["f-facilitySettingItem__menu"]} ${styles["open"]}`
          : styles["f-facilitySettingItem__menu"]
      }
      onClick={handleMenu}
    >
      <div className={styles["f-facilitySettingItem__menu-inner"]}>
        <div className={styles["f-facilitySettingItem__menu-top"]}>
          <div>{name}</div>
          <FontAwesomeIcon
            icon={["fal", "times-circle"]}
            onClick={handleMenu}
          />
        </div>
        <ul className={styles["f-facilitySettingItem__menu-list"]}>
          <li>
            <SonicLink
              to={`/mypage/facility-setting/${id}`}
              className={styles["f-facilitySettingItem__menu-list__item"]}
            >
              <FontAwesomeIcon icon={["fal", "edit"]} />
              編集
            </SonicLink>
          </li>

          {status == PageVisibility.NotPubliclyVisible ? (
            <li
              onClick={() => handlePublish(id)}
              className={styles["f-facilitySettingItem__menu-list__item"]}
            >
              <FontAwesomeIcon icon={["fal", "lock-alt"]} />
              公開申請
            </li>
          ) : null}
          {status !== PageVisibility.NotPubliclyVisible ? (
            <li
              onClick={() => handlePrivate(id)}
              className={styles["f-facilitySettingItem__menu-list__item"]}
            >
              <FontAwesomeIcon icon={["fal", "lock-alt"]} />
              非公開
            </li>
          ) : null}
          {status !== PageVisibility.DeletionRequest ? (
            <li
              onClick={() => handleDeletionRequest(id)}
              className={`${styles["f-facilitySettingItem__menu-list__item"]} ${styles["delete"]}`}
            >
              <FontAwesomeIcon icon={["fal", "trash-alt"]} />
              削除申請
            </li>
          ) : null}
          {status === PageVisibility.DeletionRequest ? (
            <li
              onClick={() => handlePrivate(id)}
              className={`${styles["f-facilitySettingItem__menu-list__item"]} ${styles["delete"]}`}
            >
              <FontAwesomeIcon icon={["fal", "trash-alt"]} />
              削除申請の取り消し
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
};

type CardProps = {
  name: string;
  img?: ImageSourceSetData;
  prefecture?: string;
};

const ListCard: React.FC<CardProps> = ({ name, img, prefecture }) => (
  <div className={cardStyles["f-listCard"]}>
    <div className={cardStyles["f-listCard__link-img"]}>
      {prefecture && (
        <span className={cardStyles["f-listCard__link-img__prefecture"]}>
          {parsePrefecture(prefecture).toLocaleUpperCase()}
        </span>
      )}
      <img src={img ? img.large.url : getDefaultImage()} alt={name} />
      <p className={cardStyles["f-listCard__link-img__name"]}>{name}</p>
    </div>
  </div>
);
